import React, { createContext, useContext, useState, useEffect } from 'react';
const TSStateContext = createContext(undefined);
const initialState = {
    currentScreen: 'bubble',
    selectedText: '',
    isPlaying: false,
    languageCode: 'en',
    voiceId: 'Danielle',
    urlAudio: '',
    isTranslating: false,
    isGettingAudio: false,
    miniPlayer: false,
    languageList: [],
    languageListWithVoice: [],
    voiceList: [],
    translatedText: '',
    playbackRate: 1,
    opensCount: 0,
    hideBubble: false
};
export const TSStateProvider = ({ children }) => {
    const [state, setState] = useState(initialState);
    /*
    const [state, setState] = useState<TSState>(() => {
      const storedState = sessionStorage.getItem('tsState');
      return storedState ? JSON.parse(storedState) : initialState;
    });
    */
    const setStateLocal = (newState) => {
        setState(prevState => {
            const updatedState = Object.assign(Object.assign({}, prevState), newState);
            // sessionStorage.setItem('tsState', JSON.stringify(updatedState));
            return updatedState;
        });
    };
    useEffect(() => {
        // sessionStorage.setItem('tsState', JSON.stringify(state));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return React.createElement(TSStateContext.Provider, { value: { state, setStateLocal } }, children);
};
export const useTSState = () => {
    const context = useContext(TSStateContext);
    if (!context) {
        throw new Error('useTSState must be used within a TSStateProvider');
    }
    return context;
};
